// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCalendarIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M6 3a1 1 0 0 1 2 0v1h8V3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1zM5 9h14v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
    />
  </g>
);
export default SvgCalendarIcon;
SvgCalendarIcon.displayName = 'SvgCalendarIcon';
